<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="400"
      persistent
    >
      <v-card>
        <v-card-title class=" grey lighten-2">
          <v-icon color="red" left >
            mdi-alert-outline
            </v-icon>Atenção
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('cancelar')" >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text>
          A exclusão deste item é definitiva, portanto não poderá ser desfeita.'
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="$emit('confirmar')"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

    export default {
        props: ['dialog'],

        data () {
            return {
            }
        }
    }
</script>